import { lazy } from 'react';

// ============================================================================
// LAZY LOADING DE PÁGINAS
// ============================================================================
// Cada página se carga SOLO cuando el usuario navega a ella.
// Esto reduce drásticamente el tiempo de carga inicial de la aplicación.
// ============================================================================

// Páginas principales (carga inmediata - las más usadas)
export { default as HomePage } from './home/home';

// Páginas con carga diferida (lazy loading)
export const ConfigurationPage = lazy(() => import('./configuration/configuration'));
export const DatePage = lazy(() => import('./date/date'));
export const PatientsPage = lazy(() => import('./patients/patients'));
export const SamplesPage = lazy(() => import('./samples/samples'));
export const ResultsPage = lazy(() => import('./results/results'));
export const BillingPage = lazy(() => import('./billing/billing'));
export const ReportsPage = lazy(() => import('./reports/reports'));
export const TraceabilityPage = lazy(() => import('./traceability/traceability'));
export const WarningsPage = lazy(() => import('./warnings/warnings'));
export const TrackingPage = lazy(() => import('./tracking/tracking'));
export const SerumLibraryPage = lazy(() => import('./serum-library/serum-library'));
export const AdminOrdersPage = lazy(() => import('./admin-orders/admin-orders'));
export const BarcodesPage = lazy(() => import('./barcodes/barcodes'));
export const ReferralsPage = lazy(() => import('./referrals/referrals'));
export const FindResultsPage = lazy(() => import('./find-results/find-results'));
export const MassPrintingPage = lazy(() => import('./mass-printing/mass-printing'));
export const MassValidationPage = lazy(() => import('./mass-validation/mass-validation'));
export const TimersPage = lazy(() => import('./timers/timers'));
export const WorkListPage = lazy(() => import('./work-list/work-list'));
export const ControlBoardsPage = lazy(() => import('./control-boards/control-boards'));
export const DashboardsPage = lazy(() => import('./dashboards/dashboards'));
export const AnalyzersPage = lazy(() => import('./analyzers/analyzers'));

// Páginas de configuración (menos frecuentes - lazy loading)
export const AnalitosPage = lazy(() => import('./Analitos/Analitos'));
export const ConfigGeneralPage = lazy(() => import('./ConfigGeneral/ConfigGeneral'));
export const ConfigQCPage = lazy(() => import('./ConfigQC/ConfigQC'));
export const MeasurementsQC = lazy(() => import('./measurements-qc/measurements-qc'));
export const MasiveMeasurementsQC = lazy(() => import('./measurements-qc/masive-measurements-qc'));
export const AlarmasPage = lazy(() => import('./Alarmas/Alarmas'));
export const AnalitosPlantillasPage = lazy(() => import('./AnalitosPlantillas/AnalitosPlantillas'));
export const AnalitosTiposMuestrasPage = lazy(() => import('./AnalitosTiposMuestras/AnalitosTiposMuestras'));
export const AnalizadoresPage = lazy(() => import('./Analizadores/Analizadores'));
export const ConfigBarcodesPage = lazy(() => import('./ConfigBarcodes/ConfigBarcodes'));
export const ConfigCamposDinamicosPage = lazy(() => import('./ConfigCamposDinamicos/ConfigCamposDinamicos'));
export const EstudiosPage = lazy(() => import('./Estudios/Estudios'));
export const EstudiosPerfilesPage = lazy(() => import('./EstudiosPerfiles/EstudiosPerfiles'));
export const ConfigPermisosPage = lazy(() => import('./ConfigPermisos/ConfigPermisos'));
export const ConfigReportesPage = lazy(() => import('./ConfigReportes/ConfigReportes'));
export const ConfigReportesInformesPage = lazy(() => import('./ConfigReportesInformes/ConfigReportesInformes'));
export const ConfigReportesDisenadorPage = lazy(() => import('./ConfigReportesDisenador/ConfigReportesDisenador'));
export const ConfigReportesDefinicionesPage = lazy(() => import('./ConfigReportesDefiniciones/ConfigReportesDefiniciones'));
export const ConfigUsuariosPage = lazy(() => import('./ConfigUsuarios/ConfigUsuarios'));
export const TareasOperativasPage = lazy(() => import('./TareasOperativas/TareasOperativas'));
export const TareasOperativasCerrarOrdenesPage = lazy(() => import('./TareasOperativasCerrarOrdenes/TareasOperativasCerrarOrdenes'));
export const TareasOperativasDisenosPage = lazy(() => import('./TareasOperativasDisenos/TareasOperativasDisenos'));
export const Quotations = lazy(() => import('./billing/Quotations/Quotations'));
export const PreordersPage = lazy(() => import('./Preorders/Preorders'));
export const ConfigFacturacionPage = lazy(() => import('./ConfigFacturacion/ConfigFacturacion'));
export const ConexionesPage = lazy(() => import('./Conexiones/Conexiones'));
export const ConfigTablasPage = lazy(() => import('./ConfigTablas/ConfigTablas'));
export const ConfigAppoiments = lazy(() => import('./ConfigAgendaCitas/ConfigAgendaCitas'));
export const AdminAgendaCitas = lazy(() => import('./AdminAgendaCitas/AdminAgendaCitas'));
export const Cashier = lazy(() => import('./billing/Cashier/Cashier'));
export const FindPatientPage = lazy(() => import('./FindPatient/FindPatient'));
export const ConfigNotasPage = lazy(() => import('./ConfigNotas/ConfigNotas'));
export const MyProfilePage = lazy(() => import('./MyProfile/MyProfile'));
export const ConfigWebPagePatientsPage = lazy(() => import('./ConfigWebPagePatients/ConfigWebPagePatients'));
export const ConfigEmailTemplatesPage = lazy(() => import('./ConfigEmailTemplates/ConfigEmailTemplates'));
export const ConfigInformedConsentsPage = lazy(() => import('./ConfigInformedConsents/ConfigInformedConsents'));
export const ConfigBackupsPage = lazy(() => import('./configBackups/configBackups'));
export const ExternalRemisionsPage = lazy(() => import('./ExternalRemisions/ExternalRemisions'));
export const TraceabilityMasiveActionsPage = lazy(() => import('./TraceabilityMasiveActions/TraceabilityMasiveActions'));
export const AboutSynerLabPage = lazy(() => import('./AboutSynerLab/AboutSynerLab'));